import { ELevel } from '@web/shared/enums/node-state/level.enum'

export const levelColor = {
  [ELevel.Level1Count]: '#84D095FF',
  [ELevel.Level2Count]: '#D4EA88FF',
  [ELevel.Level3Count]: '#FDE9A7FF',
  [ELevel.Level4Count]: '#ff9774'
} as const
